import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { LoadPanel, Lookup } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
// import { useComuniDataSource } from '../../datasources/ComuniDataSource'; //todo: RGAM non esiste più datasource comuni.

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  bloccaAnagrafica: boolean;
  readOnly?: boolean;
}

export type AssistitoEditAnagraficaPanelHandle = {
}

const AssistitoEditAnagraficaPanel: React.ForwardRefRenderFunction<AssistitoEditAnagraficaPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const formRef = useRef<FormRef>(null);

  useEffect(() => {
    setFormData(null);

    (async function () {
      const api = new AssistitiApi(apiConfiguration);
      setLoadPanelVisible(true);
      setFormData(await api.getAssistitoById({ tenantId: currentTenant.Id, assistitoId: props.assistitoId }));
      setLoadPanelVisible(false);
    })();

  }, [props.assistitoId]);

  function onFieldDataChanged(e: FieldDataChangedEvent) {
    // if (e.dataField==="dataDocumento" && e.component.getEditor('dataOperazione')?.option('value')==null){
    //     e.component.updateData("dataOperazione", e.value);
    // }   
  }

  function save_click(e: ClickEvent) {
    var validate = formRef.current?.instance().validate();

    if (validate?.isValid) {
      const api = new AssistitiApi(apiConfiguration);

      var data = formRef.current?.instance().option("formData");
      console.log("data", data);
      setLoadPanelVisible(true);
      api.updateAssistito({
        tenantId: currentTenant.Id,
        assistitoId: props.assistitoId,
        assistitoUpdateDTO: data
      })
        .then(props.onchanged)
        .catch(showError)
        .finally(() => setLoadPanelVisible(false));
    }
    else
      notify("Correggere gli errori di validazione", "error", 2000);
  }

  return (
    <React.Fragment>
      <Form id="form" ref={formRef} colCount={3} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating' readOnly={props.readOnly}>

        <Item dataField="nome" disabled={props.bloccaAnagrafica} />
        <Item dataField="cognome" disabled={props.bloccaAnagrafica} />
        <EmptyItem />
        <Item dataField="codiceFiscale" isRequired={true} disabled={props.bloccaAnagrafica} />
        <Item dataField="dataDiNascita" editorType='dxDateBox' isRequired={true} disabled={props.bloccaAnagrafica} />
        <Item dataField="sesso" editorType='dxSelectBox' isRequired={false} disabled={props.bloccaAnagrafica}
          editorOptions={{
            dataSource: [
              { value: 'M', text: 'Maschio' },
              { value: 'F', text: 'Femmina' },
              { value: '', text: '-' }
            ],
            valueExpr: 'value',
            displayExpr: 'text',
            placeholder: 'Seleziona il sesso'
          }} />
        <Item dataField="email" isRequired={false} />
        <Item dataField="telefono" isRequired={false} />
        <Item dataField="cellulare" isRequired={false} />

        <GroupItem caption="Luogo di nascita" colSpan={3} colCount={4}>
          <SimpleItem
            colSpan={4}
            render={(e) =>
              <ComuneSelector
                data={{
                  nazioneId: formData?.nascitaNazioneId,
                  regioneId: formData?.nascitaRegioneId,
                  provinciaId: formData?.nascitaProvinciaId,
                  comuneId: formData?.nascitaComuneId,
                  regione: formData?.nascitaRegione,
                  provincia: formData?.nascitaProvincia,
                  comune: formData?.nascitaComune
                }}
                onValueChanged={(data) => {
                  e?.component.updateData("nascitaComuneId", data.comuneId);
                  e?.component.updateData("nascitaProvinciaId", data.provinciaId);
                  e?.component.updateData("nascitaRegioneId", data.regioneId);
                  e?.component.updateData("nascitaNazioneId", data.nazioneId);
                  e?.component.updateData("nascitaComune", data.comune);
                  e?.component.updateData("nascitaProvincia", data.provincia);
                  e?.component.updateData("nascitaRegione", data.regione);
                }}
                readOnly={props.readOnly}
              />
            }
          />
        </GroupItem>
        <GroupItem caption="Domicilio" colSpan={3} colCount={4}>
          <Item dataField="residenzaIndirizzo" colSpan={3} >
            <Label text="Indirizzo" />
          </Item>
          <GroupItem colSpan={1} colCount={2}>
            <Item dataField="residenzaNumeroCivico" >
              <Label text="Numero civico" />
            </Item>
            <Item dataField="residenzaCAP" >
              <Label text="CAP" />
            </Item>
          </GroupItem>
          <SimpleItem
            colSpan={4}
            render={(e) =>
              <ComuneSelector
                data={{
                  nazioneId: formData?.residenzaNazioneId,
                  regioneId: formData?.residenzaRegioneId,
                  provinciaId: formData?.residenzaProvinciaId,
                  comuneId: formData?.residenzaComuneId,
                  regione: formData?.residenzaRegione,
                  provincia: formData?.residenzaProvincia,
                  comune: formData?.residenzaComune
                }}
                onValueChanged={(data) => {
                  e?.component.updateData("residenzaComuneId", data.comuneId);
                  e?.component.updateData("residenzaProvinciaId", data.provinciaId);
                  e?.component.updateData("residenzaRegioneId", data.regioneId);
                  e?.component.updateData("residenzaNazioneId", data.nazioneId);
                  e?.component.updateData("residenzaComune", data.comune);
                  e?.component.updateData("residenzaProvincia", data.provincia);
                  e?.component.updateData("residenzaRegione", data.regione);
                }}
                readOnly={props.readOnly}
              />
            }
          />
          {/* <Item dataField="residenzaComune" editorType='dxSelectBox' isRequired={false} >
            <Label text="Comune" />
          </Item>
          <Item dataField="residenzaProvincia" editorType='dxSelectBox' isRequired={false} >
            <Label text="Provincia" />
          </Item>
          <Item dataField="residenzaRegione" editorType='dxSelectBox' isRequired={false} >
            <Label text="Regione" />
          </Item>
          <Item dataField="residenzaNazione" editorType='dxSelectBox' isRequired={false} >
            <Label text="Nazione" />
          </Item> */}
        </GroupItem>

        <Item dataField="note" colSpan={3} editorType='dxTextArea' />

        <ButtonItem horizontalAlignment="right" colSpan={3} visible={!props.readOnly}
          buttonOptions={{
            text: 'Salva',
            type: 'default',
            icon: 'save',
            onClick: save_click
          }}
        />
      </Form>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditAnagraficaPanel);